import { productsReducer } from "../reducer/ProductsReducer";

export const reducer = productsReducer;